// @flow

export const AuthenticationEndpoint = './account/auth';
export const DaoEndpoint = './api/dao';
export const SearchEndpoint = './api/search';
export const SamEndpoint = './api/sam';
